export default {
	"autoreport": {
		"algoModel": "algorithm model",
		"templateCode": "template content",
		"emailTitle": "mail title",
		"fileType": "attachment format",
		"batchOperationTips": "check the data that needs to be operated",
		"tabPanleName1": "report information",
		"daily": "daily",
		"emailValidataMsg1": "email address is incorrect",
		"emailValidataMsg2": "email address has been registered",
		"emailValidataMsg3": "email address length cannot be greater than 500"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/autoreport/autoreport.js